<template lang="html">
  <SceneContent v-bind="$props"/>
</template>

<script>
/**
 * BUSINESS RULE: DO NOT ALLOW TO SAVE VACANCY IF ID EXTERNAL IS NOT SPECIFIED.
 * so,
 * - fetch id external on preferences load
 * - add watcher to its value
 * - in case id external is not specified, set flag which prevent saving vacancy with modal showing
 * - in vase id external is specified, allow to save vacancy :)
 *
 */
import SceneContent from '@/components/vacancy/preferences/SceneContent.vue'

export default {
  name: 'process-vacancy-preferences-scene',

  components: {
    SceneContent
  },

  props: {
    vacancy: Object
  },

  methods: {
    fetch () {
      this.$store.dispatch('process/citibank/vacancy/additionalData/fetch', this.vacancy)
    }
  },

  computed: {
    storeAdditionalData () {
      return this.$store.state.process.citibank.vacancy.additionalData.data
    },
    idExternal () {
      return this.$store.getters['process/citibank/vacancy/additionalData/idExternal']
    }
  },

  watch: {
    idExternal(value) {
      if (value === undefined || value === null) {
        this.$store.dispatch('vacancy/doNotAllowToSave/forbidToSave', {
          textKey: 'vacancy.preferences.modals.idExternalEmptyAlert.text'
        })
      } else {
        this.$store.dispatch('vacancy/doNotAllowToSave/clearRestriction')
      }
    }
  },

  beforeMount() {
    this.fetch()
  }
}
</script>
